import { omit } from "lodash-es";

import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { PINS_SPEED_FLAGS, stripIncludeFlags } from "@app/util/map/leanPinsRequest";

const NON_CONTEXT_KEYS = [
  "pinLegends",
  "cadence",
  "strictColumns",
  ...Object.keys(PINS_SPEED_FLAGS),
];

// The fetch's $filters minus the server-side options that say how to fetch, not what is filtered.
const toContextFilters = (filters: PlatformFilterModel): PlatformFilterModel =>
  omit(stripIncludeFlags(filters), NON_CONTEXT_KEYS);

export default toContextFilters;
